<template>
  <div id='app'>
    <!--    <xk-login></xk-login>-->
    <xk-home-but v-if="!loadState"></xk-home-but>
    <div class="MidContent">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
  import cookieJS from 'js-cookie'
  import wx from 'weixin-js-sdk'
  import { mapGetters } from 'vuex'
  import XkUploadMod from './components/module/uploadMod/src/uploadMod'
  import XkHomeBut from './components/module/homeBut/src/homeBut'
  import InitData from './store/configure'
  import Tool from './assets/js/method.js'

  export default {
    components: {
      XkHomeBut,
      XkUploadMod
      // XkLogin
    },
    name: 'app',
    data: () => {
      return {
        loadState: false,
        phone: '', // 免登手机号
        sign: null, // 免登签名 header
        timeStamp: null, // 免登签名 时间戳
        clientId: null // 授权 ID header
      }
    },
    computed: {
      ...mapGetters({
        loginData: 'loginData',
        infoData: 'infoData',
        login: 'login',
        positioning: 'positioning'
      })
    },
    methods: {
      getInitInfoFn () {
        let that = this
        let init = new Promise(function (resolve, reject) {
          that.$store.dispatch('getInitInfo', { // 调用的公司接口 /v1/company
            city_code: true,
            ad_code: true,
            fn (data) {
              if (data && data.code === 1) {
                resolve(data)
              } else {
                reject(data)
              }
            }
          })
        })
        init.then(function (data) {
          if (that.phone && that.sign && that.clientId && that.timeStamp) {
            let passengerkey = window.configure.passengerKey
            Tool.delCookie(passengerkey)
            Tool.delCookie('easyminaddressrecord')
            cookieJS.remove(passengerkey)
            that.$store.dispatch('passengerWithOutLogin', {
              phone: that.phone,
              sign: that.sign,
              clientId: that.clientId,
              timeStamp: that.timeStamp,
              fn (data) {
                if (data && data.code === 1) {
                  // that.$store.dispatch('checkLogin')
                }
              }
            })
          } else {
            // that.$store.dispatch('checkLogin')
          }
          window.configure['companyinfo'] = data.companyinfo
          cookieJS.set('companyinfo', JSON.stringify(data.companyinfo))
          that.loadState = false
        }).catch(function (err) {
          console.log(err)
        })
      },
      /**
       * 获取高德key
       */
      async getAmapKey () {
        let url = '/v1/systemConfig'
        let params = {
          app_key: this.$route.query.app_key
        }
        let data = await this.$axios.get(url, params)
        if (data && data.code === 1) {
          window.configure.amapKey = data.system.amap_key || '5e87734d0804fbc33ec68b5e69d052ec'
        }
      }
    },
    watch: {
      '$route': {
        handler (val) {
          console.log('路由监听', val)
          let appKey = this.$route.query.app_key || window.configure.appKey
          if (val.path === '/') {
            this.$router.push({
              path: '/daijia?app_key=' + appKey
            })
          }
        },
        deep: true
      }
    },
    created () {
      let cookieAppKey = cookieJS.get('cookieAppKey') ? cookieJS.get('cookieAppKey') : null
      this.phone = this.$route.query.phone
      this.timeStamp = this.$route.query.timeStamp
      if (this.phone) this.phone = this.phone.replace(/ /g, '+')
      this.sign = this.$route.query.sign
      this.clientId = this.$route.query.clientId
      console.log('APP-created-cookieAppKey', cookieAppKey)
      let appKey = this.$route.query.app_key || cookieAppKey
      if (this.$route.path === '/' || this.$route.path === '/daijia') {
        Tool.setCookie('cookieAppKey', appKey) // 将该代驾公司登录的用户写入cookie
      }
      if (appKey) {
        InitData.appKey = window.configure.appKey = appKey
        window.configure.passengerKey = 'passenger' + appKey
      } else {
        alert('请配置微信AppKey!')
      }
    },
    mounted: function () {
      var that = this
      that.getAmapKey()
      that.loadState = true
      that.$store.dispatch('positioningActions', {
        fn (state) {
          // console.log('APP-mounted--positioning定位--state', state)
          if (state) {
            that.getInitInfoFn()
            that.$store.dispatch('getWxAppId', {
              fn (data) {
                if (data && data.code === 1) {
                  window.configure.WXappId = data.wechat.app_id
                  InitData.WXappId = window.configure.WXappId
                  that.$store.dispatch('accredit', (data) => {
                    // console.log('accredit', data)
                    if (data.wxState && data.code) { // 只有微信环境下code存在
                      that.$store.dispatch('getOpenId', {
                        jsCode: data.code,
                        wxAppId: window.configure.WXappId,
                        fn (data) {
                          that.$store.dispatch('postloginOpenId', {
                            open_id: window.configure.open_id,
                            fn (data) {
                              console.log('APP-走loginOpenId', data)
                            }
                          })
                        }
                      })
                    }
                  })
                }
              }
            })
          } else {
            that.$nextTick(() => {
              that.$store.dispatch('getWeChatToken', {
                wxAppId: window.configure.WXappId,
                fn (data) {
                  if (data && data.code === 1) {
                    that.$store.dispatch('getjsApiTicket', {
                      url: window.location.href.split('#')[0],
                      fn (data) {
                        if (data && data.code === 1) {
                          wx.config({
                            debug: false,
                            appId: window.configure.WXappId, // 必填，企业号的唯一标识，此处填写企业号corpid
                            timestamp: data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: data.noncestr, // 必填，生成签名的随机串
                            signature: data.sign, // 必填，签名，见附录1
                            jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                          })
                        }
                      }
                    })
                  }
                }
              })
              that.$nextTick(() => {
                // that.$store.dispatch('positioning', {
                //   fn (state) {
                //     console.log('position', state)
                //     if (state) {
                //       that.getInitInfoFn()
                //       that.$store.dispatch('checkLogin', (state) => {
                //         // console.log('app-checkLogin-state', state)
                //         if (state) {
                //         }
                //       })
                //     }
                //   }
                // })
              })
            })
          }
        }
      })
    }
  }
</script>

<style rel="stylesheet/less" lang="less">
  @import './assets/fonts/iconfont.css';

  @titleColor: #535353; //标题颜色
  @iconColor: #333; //黑色
  @themeColor: #f06553; // 主题色
  * {
    padding: 0;
    margin: 0;
    font-weight: normal;
    -webkit-overflow-scrolling: touch;
    -webkit-tap-highlight-color: rgba(240, 240, 240, 0);
  }

  ::-webkit-scrollbar {
    background: red;
  }

  ::-webkit-scrollbar {
    display: none !important; /*隐藏滚轮*/
    opacity: 0 !important;
  }

  ::-webkit-scrollbar-track {
    opacity: 0 !important;
  }

  ::-webkit-scrollbar-thumb {
    opacity: 0 !important;
  }

  html {
    /*font-size: 62.5%;*/
    font-size: 75%;
    min-height: 100%;
  }

  .picker {
    z-index: 300;
  }

  @media screen and (min-width: 125px) {
    html {
      font-size: 80%;
    }
  }

  @media screen and (min-width: 375px) {
    html {
      font-size: 80%;
    }
  }

  body {
    width: 100%;
    background-color: #f3f4f5;
    min-height: 100%;
  }

  ul, li, ol {
    list-style: none;
  }

  a {
    display: inline-block;
    text-decoration: none;
  }

  span {
    display: inline-block;
  }

  input, textarea {
    outline: none
  }

  .router-link-active, .router-link-exact-active {
    background-color: rgba(0, 0, 0, 0);
  }

  .clear:after {
    content: "200B";
    height: 0;
    clear: both;
    font-size: 0;
    display: block;
    *zoom: 1;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    width: 100vw;
    height: 100vh;
    background: #f3f4f5;
  }

  .MidContent {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
  }

  /** 弹窗**/
  .modelBox {
    .Box {
      position: fixed;
      min-width: 46.666666%;
      max-width: 75%;
      height: auto;
      background-color: #fff;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      border-radius: 0.33333rem;
      overflow: hidden;
      z-index: -100;
      opacity: 0;
      transition: 0.3s all;
      text-align: center;

      .modelBoxContent {
        padding: 1rem;
      }

      .modelBoxBottom {
        height: 2.8rem;
        width: 100%;
        overflow: hidden;

        .ActionBut {
          width: 50%;
          box-sizing: border-box;
          text-align: center;
          float: left;
          line-height: 2.8rem;
        }

        .OKBut {
          background-color: #eeeeee;
          color: #bbbbbb;
          border-radius: 0 0 0 0.33333rem;
        }

        .NoBut {
          background-color: #f06553;
          color: #fff;
          border-radius: 0 0 0.33333rem 0;
        }
      }
    }

    .modelBoxModel {
      position: fixed;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      z-index: -100;
      transition: 0.3s all;
    }
  }

  .modelRgba {
    position: absolute;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background: #fff;
  }
</style>



// WEBPACK FOOTER //
// App.vue?7b5dd528